










import { defineComponent, inject, onBeforeUnmount, ref } from "@vue/composition-api";
import { NSFWSettingsSubjectType } from "@scrile/api-provider/dist/api/NSFWSettingsProvider";
import providers from "@/lib/api";
import config from "@/config";
import BaseCheckbox from "@/components/BaseCheckbox";

export default defineComponent({
  name: "SafeForWorkOption",
  components: { BaseCheckbox },
  props: {
    postId: { type: String, required: true },
  },
  setup(props) {
    const setUpdateCb = inject<(cb: () => Promise<void>) => void>("setUpdateCb", async () => {});
    const removeCb = inject<(cb: () => Promise<void>) => void>("removeCb", async () => {});
    const status = ref(false);
    const loading = ref(false);
    const updateSFW = async () => {
      await providers.NSFWSettingsProvider.update({
        data: {
          subject: { subjectId: props.postId, subjectType: NSFWSettingsSubjectType.POST },
          safeForWork: status.value,
        },
      });
    };

    const getStatus = async () => {
      if (!config.featureNSFW) return;
      try {
        loading.value = true;
        const response = await providers.NSFWSettingsProvider.search({
          data: { subjects: [{ subjectId: props.postId, subjectType: NSFWSettingsSubjectType.POST }] },
        });
        status.value = response.length ? response[0].safeForWork : false;
      } finally {
        loading.value = false;
      }
    };

    getStatus();

    setUpdateCb(updateSFW);
    onBeforeUnmount(() => {
      removeCb(updateSFW);
    });

    return {
      status,
      config,
      loading,
    };
  },
});
